export const contactNumber = "60137072480";
export const callLink = `tel:+${contactNumber}`;
export const whatsappLink = `https://wa.me/${contactNumber}`;
